import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import DestinationsService from '../../../../services/DestinationsService'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Spa.scss'
import TextAreaInput from '../../../atoms/form/TextAreaInput/TextAreaInput'
import { locationOptions } from '../../../../constants/RestaurantHotelContentConst'

class Spa extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }
        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            error: undefined,
            isLoading: true,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            continueFlow: this.props.history.location?.state?.continueFlow,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            initialValues: { ...this.initialValues },
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            locationOptions: locationOptions,
            spaTableId: -1
        }
    }

    initialValues = {
        typeCode : "spa", 
        name: "",
        description: "",
        phoneCountryCode: "",
        phoneAreaCode: "",
        phoneNumber: "",
		location: "",
		serviceUrl: "",
		websiteUrl: "",
        operatingHours: {
            dailyDoesntVary: {
                hours: {
                    allDays: {
                        opening: "",
                        closing: ""
                    }
                }
            }
        },
        details : [
            
        ]
    }

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;

            if (hotelDestinations) {
                await this.buildFormValues(hotelDestinations);
            } else {
                this.setState({ error: 'Could not retrieve details', isLoading: false })
            }
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;

                    if (hotelDestinations) {
                        await this.buildFormValues(hotelDestinations);
                    }
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve details', isLoading: false })
                })
        }
    }

    async buildFormValues(hotelDestinations) {
        let existingBusinesses = []
        let otherDestinationEntries = {}
        let spa = null;
        const businesses = hotelDestinations.business;
        if (hotelDestinations !== undefined && Object.keys(hotelDestinations).length > 0) {
            otherDestinationEntries = {
                ...hotelDestinations,
                business: undefined
            }
        } else {
            otherDestinationEntries = {
                business: undefined
            }
        }
        if (businesses) {
            businesses.forEach((business, index) => {
                if (business.destinationType === FormConst.DESTINATION_TYPE_SPA) {
                    spa = { 
                        ...business, 
                        detailedLocation: business.locationInfo?.location,
                        detailedLocationDescription: business.locationInfo?.description,
                        phoneCountryCode: business.phoneNumber ? business.phoneNumber.countryCode : "",
                        phoneAreaCode: business.phoneNumber ? business.phoneNumber.areaCode : "",
                        phoneNumber: business.phoneNumber && business.phoneNumber.number? business.phoneNumber.number.replace(/-/g, '') : "" 
                    };
                    if (spa.description === undefined) {
                        spa = {
                            ...spa,
                            description: ""
                        }
                    }

                } else {
                    existingBusinesses.push(business)
                }
            })
        }
        
        if (spa === null) {
            spa = this.initialValues;
        }
        this.setState({
            existingBusinesses: existingBusinesses,
            initialValues: spa,
            otherDestinationEntries: otherDestinationEntries,
            isLoading: false
        })
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return match[1] + '-' + match[2] + '-' + match[3];
        }
        return '';
    }

    async handleSubmit(formData) {
        let newEntry = {
            destinationType: FormConst.DESTINATION_TYPE_SPA,
            name: formData.name.trim(),
            description: formData.description,
            locationInfo: {
                location: formData.detailedLocation,
                description: formData.detailedLocationDescription
            },
            serviceUrl: formData.serviceUrl,
            url: formData.url,
            phoneNumber: {
                areaCode: formData.phoneAreaCode,
                countryCode: formData.phoneCountryCode,
                number: formData.phoneNumber,
                preferred: false
            },
            operatingHours: formData.operatingHours.open && formData.operatingHours.close
                ? {
                    open: formData.operatingHours.open,
                    close: formData.operatingHours.close
                }
                : undefined
        }

        let newDestinationEntries
        if (this.state.otherDestinationEntries) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                business: [...this.state.existingBusinesses, newEntry]
            }
        } else {
            newDestinationEntries = {
                business: [...this.state.existingBusinesses, newEntry]
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })
        newEntry = {
            ...newEntry,
            phoneCountryCode: newEntry.phoneNumber ? newEntry.phoneNumber.countryCode : "",
            phoneAreaCode: newEntry.phoneNumber ? newEntry.phoneNumber.areaCode : "",
            phoneNumber: newEntry.phoneNumber && newEntry.phoneNumber.number? newEntry.phoneNumber.number.replace(/-/g, '') : "",
            detailedLocation: formData.detailedLocation,
            detailedLocationDescription: ("Floor" === formData.detailedLocation || "Other" === formData.detailedLocation) ? null : formData.detailedLocationDescription
        }
        this.setState({
            isLoading: true,
            initialValues: newEntry,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        this.setState({
            showResetModal: false
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: RouteConst.ROUTE_AIRPORTS_PAGE,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Destinations page
            this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingBusiness
                    }
                })
            } else {
                this.setState({
                    isLoading: false,
                    showDeleteModal: false
                })
                // Go back to Destinations page on successful save.
                this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
            }
        }
    }

    validationSchema = Yup.object().shape({
        name: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED).max(120, `Maximum 120 characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        description: Yup.string().max(FormConst.MAX_LENGTH_SHORT_DESCRIPTION, `Maximum ${FormConst.MAX_LENGTH_SHORT_DESCRIPTION} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS).required(FormConst.VALIDATION_ERROR_REQUIRED),
        phoneCountryCode: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(3, `Max 3 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneAreaCode || !!this.parent.phoneNumber) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        phoneAreaCode: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(3, `Max 3 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneCountryCode || !!this.parent.phoneNumber) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        phoneNumber: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(10, `Max 10 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneAreaCode || !!this.parent.phoneCountryCode) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        detailedLocationDescription: Yup.string().test('detailedLocationDescription', 
            function(val) {
                if ((detailedLocation[1].value == 'Floor' || detailedLocation[1].value == 'Other') && !val) {
                    return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                }
                return true;
            }
        ),
        serviceUrl: Yup.string().max(240, 'Max length 240 characters')
            .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
        url: Yup.string()
            .max(240, 'Max length 240 characters')
            .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
        operatingHours: Yup.object({
            open: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
            close: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        })
    })

    render() {
        return (
            <div className='hotel-content-spa-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">On-Site Spa</li>
                    </ol>
                </nav>
                
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                        resetForm()
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form id="hotelContentSpaForm" className='hotel-content-spa-form-element'>
                            <p>This section will ask for information about your On-site Spa. In another section called Buisnesses, you will have an opportunity to add other nearby Spas. This information will be shown on your property page and used to help sell your hotel.</p>
                            <div id='hotel-content-spa-form-fields' className={`hotel-content-spa-form-fields ${this.state.shouldHideEditAreaClassName}`}>
                                <Row className='leftAlignRow'>
                                    <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                        <TextInput id='name' name='name' type='text' label='Name' isrequired='true' />
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                    
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 20, offset: 0 }} className="shortDescriptionArea">
                                        <p className='helper-text'>Short Description*</p>
                                        <TextAreaInput
                                            id='short-description-text-area'
                                            name='description'
                                            maxLength={FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription}
                                            rows={10}
                                            isrequired='true'
                                            title='Short Description' />
                                        <p className='float-right'>Characters left: {FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription - values.description.length}</p>
                                    </Col>
                                </Row>
                                <p className='caption'>Timing Options</p>
                                <Row className='leftAlignRow'>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='operatingHours.open' 
                                            name='operatingHours.open' type='time' label='Opening Time' 
                                            isrequired='true' />
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='operatingHours.close' 
                                            name='operatingHours.close' type='time' label='Closing Time' 
                                            isrequired='true'  />
                                    </Col>
                                </Row>
                                <p className='caption'>Contact Details</p>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput
                                            id='spa-phone-number'
                                            name='phoneCountryCode'
                                            type='tel'
                                            label='Phone Number'
                                            placeholder='CC'
                                            title='Country Code'
                                            suffix={
                                                <>
                                                    <TextInput
                                                        id='area-code'
                                                        name='phoneAreaCode'
                                                        type='num'
                                                        label=' - '
                                                        title='Area Code'
                                                        placeholder='Area Code' />
                                                    <TextInput
                                                        id='phone-number'
                                                        name='phoneNumber'
                                                        type='tel'
                                                        label=' - '
                                                        title='Phone Number'
                                                        placeholder='Number' />
                                                </>
                                            }
                                            isrequired='false' />
                                        </Col>
                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <SelectInput id='detailedLocation' name='detailedLocation' type='tel' label='Detailed Location' options={this.state.locationOptions} />
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='serviceUrl' name='serviceUrl' type='text' label='Services URL' isrequired='false' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                    {
                                    (values.detailedLocation == 'Floor' || values.detailedLocation == 'Other') &&
                                        <TextInput id='detailedLocationDescription' name='detailedLocationDescription' label={values.detailedLocation == 'Floor' ? 'Floor' : 'Other'} type='text' isrequired='true' />
                                    }
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='url' name='url' type='text' label='Website URL' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-restaurant-action-button" formNoValidate /></Col>
                                    <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-restaurant-action-button" onClick={() => {
                                        if (dirty) {
                                            this.handleClearForm()
                                        } else {
                                            this.discardNewFields(resetForm)
                                        }
                                    }
                                    }
                                        overridedisabledflag='true' /></Col>
                                </Row>
                            </div>
                            {
                                this.state.showNewSpaFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }
                            <FormFooter
                                form={{
                                    previous: { title: 'Businesses', route: RouteConst.ROUTE_BUSINESSES_PAGE },
                                    next: { title: 'Airports', route: RouteConst.ROUTE_AIRPORTS_PAGE }
                                }}
                                submitName={this.state.continueFlow ? 'Proceed to Transportation' : 'Go back to Destinations'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewSpaFields}
                                noReset />
                            <FormModal
                                id='spa-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='spa-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='spa-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Spa'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='spa-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                        )}
                        </Formik>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(Spa, SideNavEntryMapping.HOTEL_DESTINATIONS))